import React, { useState, useContext, useRef, useEffect } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
import { DateTime } from "luxon";
import { useIntl, FormattedMessage } from "react-intl";

import UserContext from "../contexts/user";
import EventContext from "../contexts/event";

import SidebarMain from "../components/sidebar-main";
import SchedulePresentation from "../components/schedule/presentation";

import {
  EventData,
  ScheduleEndpointResponseObject,
  Version,
  VersionList,
} from "../types/presentation";
import EditProfileModal from "../components/edit-profile-modal";
import LocaleSwitcher from "../components/locale-switcher";
import PresentationItem from "../components/speaker/presentationItem";
// import NewVideoItem from "./new-video-item";
import SidebarNewVideo from "../components/sidebar-new-video";
import ReactPlayer from "react-player";
import DocViewer from "react-doc-viewer";
import { IDocument } from "react-doc-viewer/build/types";
import { Document, Page } from "react-pdf";
import Slider from "react-slick";
import getEncodedImageUrl from "../helpers/get-encoded-image";
import SproutVideo from "../components/sprout-video";
import { useFullScreenHandle } from "react-full-screen";
import { useQuery, useQueryClient } from "react-query";
import axios from "axios";
import dayjs from "dayjs";
import useLocalStorage from "react-use-localstorage";

import { filter } from "lodash";
import { duration } from "../helpers/duration";
const PublicVideo: React.FC<{
  isSpeaker: boolean;
  eventData: EventData;
  locale: string;
  setLocale: (arg0: string) => void;
}> = ({ eventData, locale, setLocale, isSpeaker }) => {
  const { presentation_id, event_slug, version_id } = useParams<{
    presentation_id: string;
    event_slug: string;
    version_id: string;
  }>();

  const history = useHistory();

  const intl = useIntl();
  const location = useLocation();
  const userContext = useContext(UserContext);
  const eventContext = useContext(EventContext);
  const [isVirtual] = useState(
    queryString.parse(location.search).viewmode === "virtual"
  );
  const [isIframe] = useState(queryString.parse(location.search).iframe);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [uploadTab, setUploadTab] = useState("");
  const [singleVersion, setSingleVersion] = useState<Version>();
  const [rightVideo, setRightVideo] = useState("");
  const [leftVideo, setLeftVideo] = useState("");
  const [uploadDocument, setUploadDocument] = useState("");
  const [played, setPlayed] = useState(false);
  const [v, setV] = useState(null);
  const [w, setW] = useState(null);
  const [currentThumbnail, setCurrentThumbnail] = useState(0);
  const [swap, setSwap] = useState(false);
  const [cornerStyle, setCornerStyle] = useState({});
  const [progress, setProgress] = useState(0);

  const [filter, setFilter] = useState<{
    speakers: Array<string>;
    rooms: Array<string>;
    associations: Array<string>;
    dates: Array<string>;
    activeQuizzesOnly: boolean;
  }>({
    speakers: [],
    rooms: [],
    associations: [],
    dates: [],
    activeQuizzesOnly: false,
  });
  let previousDate: string | null = null;
  const days = eventData.aggregates.dates.sort((a: string, b: string) =>
    a.localeCompare(b)
  );

  const handleVideoFile = (event: any) => {
    setRightVideo(URL.createObjectURL(event.target.files[0]));
  };

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div className={className} style={{ ...style }} onClick={onClick}>
        <img src="/icons/arrow-right.svg" alt="next" />
      </div>
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div className={className} style={{ ...style }} onClick={onClick}>
        <img src="/icons/arrow-left.svg" alt="next" />
      </div>
    );
  }

  const seekVideo = (value: any) => {
    // setProgress(value);
    if (!played) {
      // @ts-ignore
      v.play();

       console.log("w", w);
    }
    if (w) {
      // if webcam is present, seek webcam, it will internally seek the video

      // @ts-ignore
      w.seek(value);
      // video.seek(value);
    } else {
      // if no webcam, seek the video
      // @ts-ignore
      v.seek(value);
    }
  };
  const sliderRef = useRef() as React.MutableRefObject<Slider>;
  const screen = useFullScreenHandle();

  const handleScreen = () => {
    if (screen.active) {
      screen.exit();
    } else {
      screen.enter();
    }
  };
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const queryClient = useQueryClient();
  const [fetchData, setFetchData] = useState(false);
  const [eventPassword] = useLocalStorage(event_slug, "");
   console.log("eventPassword", eventPassword);
  let token: any = localStorage.getItem(`token-${event_slug}`);
  const [time, setTime] = useState("");

  const { data, isLoading, error } = useQuery(
    "event",
    async () => {
      const url =
        process.env.REACT_APP_API_ENDPOINT +
        "/api/public/schedule/" +
        event_slug;
       console.log("url in public video", url);

      const response = await axios.get<ScheduleEndpointResponseObject>(url, {
        params: { password: eventPassword },
      });
      return response.data;
    },
    {
      enabled: fetchData,
      onSuccess: (resp) => {
        const { event } = resp.data;
         console.log("event", event);

        resp.data.presentations.forEach((presentation) => {
          queryClient.setQueryData(["presentation", presentation._id], () => ({
            statusCode: 201,
            message: "event.fetch-success",
            data: { event, presentation },
          }));
        });
      },
    }
  );
  useEffect(() => {
    axios
      .get<VersionList>(
        `
        ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/presentation/${presentation_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        let versionItem = response.data.data.versions.filter(function (
          version
        ) {
          return version.versionId == version_id;
        });

        if (versionItem.length) {
          setSingleVersion(versionItem[0]);
          axios
            .get(
              `${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/video-details/${presentation_id}/video/${versionItem[0].webcam.id}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
            .then((response) => {
               console.log(
                "response -----------------------------------------------------------------------------------------------------",
                response.data.thumbnails[0]
              );
              setTime(response.data.duration);
            })
            .catch((error) => {
               console.log(error);
            });
        }

        //  console.log(
        //   "response presentation-----------------------------------------------------------------------------------------------------",
        //   response.data.data.versions
        // );
        /*  setSinglePresentation(response.data.data);
          setVerions(response.data.data.versions);
          const presentation_version: Version[] = response.data.data.versions;
          checkedState.length = presentation_version.length;*/
        // checkedState.fill(false);
         console.log(
          "singlePresentation---------------------------------------------------------------------------------------",
          response
        );
      })
      .catch((error) => {
         console.log(error);
      });
  }, []);

  useEffect(() => {
    if (!singleVersion) {
      return;
    }
    let video: any = null;
    let webcam: any = null;
    if (singleVersion.video && singleVersion.video.id) {
      // @ts-ignore
      video = new global.SV.Player({ videoId: singleVersion.video.id });
      if (v == null) {
        setV(video);
      }
    }

    if (singleVersion.webcam && singleVersion.webcam.id) {
      // @ts-ignore
      webcam = new global.SV.Player({ videoId: singleVersion.webcam.id });
      if (w == null) {
        setW(webcam);
      }
    }

    if (video) {
      video.bind("ready", (e: any) => {
         console.log("debug: video ready");
      });
      video.bind("play", (e: any) => {
        //  console.log('debug: video play')
        setPlayed(true);
        if (webcam) {
           console.log("debug: webcam play");

          webcam.play();
        }
      });
      video.bind("pause", (e: any) => {
        //  console.log('debug: video pause')
        if (webcam) {
          webcam.pause();
        }
      });
      video.bind("progress", (e: any) => {
        //  console.log('debug: video progress', e.data.time)
        setProgress(e.data.time);
      });
    }

    if (webcam) {
      // webcam.bind("ready", function(e) {
      //   // webcam.setVolume(1);
      //   // video.setVolume(0);
      // });
      // webcam.bind("play", (e:any) => {
      //   video.play();
      // });
      // webcam.bind("pause", function(e) {
      //   video.pause();
      // });
      webcam.bind("progress", (e: any) => {
        if (
          video.getCurrentTime() + 0.5 < webcam.getCurrentTime() ||
          video.getCurrentTime() - 0.5 > webcam.getCurrentTime()
        ) {
           console.log(
            "video is more than 0.5 seconds off the webcam, adjust it"
          );
          video.seek(e.data.time);
        }
      });
    }
  }, [singleVersion]);

  useEffect(() => {
    if (!singleVersion || !singleVersion.thumbnails) {
      return;
    }
    const thumbnail = singleVersion.thumbnails.findIndex(
      (t) => t.time > progress * 1000
    );

    if (sliderRef && sliderRef.current) {
      if (thumbnail === -1) {
        // end of ppt
        // @ts-ignore
        sliderRef.current.slickGoTo(singleVersion.thumbnails.length - 1);
        setCurrentThumbnail(singleVersion.thumbnails.length - 1);
      } else {
        // @ts-ignore
        sliderRef.current.slickGoTo(thumbnail === 0 ? 0 : thumbnail - 1);
        setCurrentThumbnail(thumbnail === 0 ? 0 : thumbnail - 1);
      }
    }
  }, [progress, singleVersion, sliderRef]);

  return (
    <div className="home-container-with-login">
      <div
        className={`grid-contianer ${isIframe ? "iframe-mode-container" : ""}`}
      >
        <LocaleSwitcher locale={locale} setLocale={setLocale} />
        {/* <div className="sidebar">
          <SidebarNewVideo
            event={eventData.event}
            aggregates={eventData.aggregates}
            filter={filter}
            setFilter={setFilter}
            openProfileModal={openProfileModal}
            setOpenProfileModal={setOpenProfileModal}
            presentationName={"Presentation"}
            PresentationDate={"Date"}
          />
        </div> */}
        <div className="main new-video-main p-t-50">
          {singleVersion ? (
            <Container>
              {isIframe && (
                <Row className="top-menu-container m-b-20">
                  <Col md={4}></Col>
                  <Col>
                    <div className="top-menu pad-0 top-menu-mob">
                      <Button
                        className={`nav-link ${
                          filter.activeQuizzesOnly ? "" : "active"
                        }`}
                        onClick={() =>
                          setFilter({ ...filter, activeQuizzesOnly: false })
                        }
                      >
                        <img src="/icons/schedule-ico.svg" alt="schedule" />
                        <span className="text">
                          <FormattedMessage id="menu.schedule" />
                        </span>
                      </Button>
                      <Button
                        className="nav-link d-none d-lg-block"
                        onClick={() => alert("work in progress")}
                      >
                        <img src="/icons/synopsis-ico.svg" alt="Synopsis" />
                        <span className="text">
                          <FormattedMessage id="menu.synopsis" />
                        </span>
                      </Button>
                      {userContext.user && (
                        <>
                          <Button
                            className="nav-link"
                            onClick={() =>
                              setOpenProfileModal(!openProfileModal)
                            }
                          >
                            <img src="/icons/profile-ico.svg" alt="PROFILE" />
                            <span className="text">
                              <FormattedMessage id="menu.profile" />
                            </span>
                          </Button>
                          <Button
                            className="nav-link"
                            onClick={() => {
                              userContext.setListUser(
                                JSON.stringify({ id: "", token: "" })
                              );
                            }}
                            to="#"
                          >
                            <img src="/icons/profile-ico.svg" alt="PROFILE" />
                            <span className="profile-tick"></span>
                            <span className="text">
                              <FormattedMessage id="menu.logout" />
                            </span>
                          </Button>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="new-schedule">
                <Col className="schedule-watch-contianer">
                  <Col sm={11} md={11} lg={11}>
                    <div className="d-flex bd-highlight watch-header">
                      <div className="p-2 flex-grow-1 bd-highlight">
                        <div className="back-to-videos">
                          <a
                            className=""
                            onClick={function () {
                              history.push(
                                `/${eventContext.slug}/my-presentations/${presentation_id}/videos`
                              );
                            }}
                          >
                            <img
                              src="/icons/back-blue.png"
                              alt="presentations"
                            />
                            <span className="text">
                              <FormattedMessage id="menu.back.to.my.videos" />
                            </span>
                          </a>
                        </div>
                      </div>

                      <div className="p-2 bd-highlight">
                        <div className="d-flex bd-highlight ">
                          <div className="time">
                            <span>Duration : {duration(time)}</span>
                          </div>
                          <div className="d-flex date">
                            <span>
                              {dayjs(singleVersion.date).format("h:mm A")}
                            </span>
                            <span>
                              {dayjs(singleVersion.date).format("DD/MM/YYYY")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="watch-version">
                      <div className="col-sm-12 col-md-12 col-lg-12 padding-0 ">
                        <div className="no-gutters row ">
                          <div className="col-sm-5 col-md-5 col-lg-5">
                            <div className="left-box">
                              <div
                                className={
                                  swap ? "video-big-container" : "mini-player"
                                }
                                style={swap ? {} : cornerStyle}
                              >
                                {!swap ? (
                                  <div
                                    onClick={() => {
                                       console.log("here 111");
                                      if (v !== null) {
                                         console.log("here 2222", v);
                                        // @ts-ignore
                                        v.play();
                                        // @ts-ignore
                                        v.setVolume(1.0);
                                      }
                                    }}
                                    className="overlay"
                                  ></div>
                                ) : null}
                                {singleVersion.webcam &&
                                  singleVersion.webcam.id && (
                                    <SproutVideo
                                      {...singleVersion.webcam}
                                      skip={0}
                                      className="video"
                                      volume={1}
                                      showcontrols={true}
                                    />
                                  )}
                              </div>
                            </div>
                          </div>

                          <div className="col-sm-7 col-md-7 col-lg-7">
                            <div className="right-box">
                              <div
                                className={
                                  swap ? "mini-player" : "video-big-container"
                                }
                                style={swap ? cornerStyle : {}}
                              >
                                {singleVersion.video ? (
                                  <SproutVideo
                                    {...singleVersion.video}
                                    skip={0}
                                    className="video"
                                    volume={
                                      singleVersion.webcam &&
                                      singleVersion.webcam.id
                                        ? 0
                                        : 1
                                    }
                                    showcontrols={true}
                                  />
                                ) : (
                                  <i>No video</i>
                                )}
                              </div>
                              {singleVersion.video && (
                                <div className="slides-summary">
                                  <Slider
                                    ref={sliderRef}
                                    className="slides-slider d-none d-lg-block"
                                    {...settings}
                                  >
                                    {singleVersion.thumbnails &&
                                      singleVersion.thumbnails
                                        .sort((a, b) => a.time - b.time)
                                        .map((thumbnail, index) => (
                                          <a
                                            key={thumbnail.time}
                                            data-time={thumbnail.time}
                                            href="/"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              seekVideo(thumbnail.time / 1000);
                                              sliderRef.current.slickGoTo(
                                                index
                                              );
                                            }}
                                            className={`item`}
                                          >
                                            <div className="m-10">
                                              <img
                                                className="img-fluid"
                                                src={getEncodedImageUrl(
                                                  thumbnail.id.indexOf(
                                                    "e-slides.net"
                                                  ) > -1
                                                    ? thumbnail.id.split(
                                                        "e-slides.net/"
                                                      )[1]
                                                    : thumbnail.id,
                                                  180,
                                                  101
                                                )}
                                                alt={`Slide ${index + 1}`}
                                              />
                                            </div>
                                          </a>
                                        ))}
                                  </Slider>
                                  <div className="d-block d-lg-none">
                                    <div className="slides-mob-container">
                                      {singleVersion.thumbnails &&
                                        singleVersion.thumbnails
                                          .sort((a, b) => a.time - b.time)
                                          .map((thumbnail, index) => (
                                            <a
                                              key={thumbnail.time}
                                              data-time={thumbnail.time}
                                              href="/"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                seekVideo(
                                                  thumbnail.time / 1000
                                                );
                                              }}
                                              className={`item ${
                                                currentThumbnail === index
                                              }`}
                                            >
                                              <div className="m-10">
                                                <img
                                                  className="img-fluid"
                                                  src={getEncodedImageUrl(
                                                    thumbnail.id.indexOf(
                                                      "e-slides.net"
                                                    ) > -1
                                                      ? thumbnail.id.split(
                                                          "e-slides.net/"
                                                        )[1]
                                                      : thumbnail.id,
                                                    274,
                                                    174
                                                  )}
                                                  alt={`Slide ${index + 1}`}
                                                />
                                              </div>
                                            </a>
                                          ))}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <Button
                              type="button"
                              className="edit-chapters"
                              color="link"
                            >
                              <img src="/icons/edit-pencil.svg" alt="" />
                              EDIT CHAPTERS
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Col>
              </Row>
            </Container>
          ) : (
            ""
          )}
        </div>
      </div>
      <EditProfileModal
        openProfileModal={openProfileModal}
        setOpenProfileModal={setOpenProfileModal}
      />
    </div>
  );
};

export default PublicVideo;
